"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const component_1 = __importStar(require("./component"));
const defaults_1 = require("./defaults");
class Page extends base_1.default {
    constructor(data = {
        id: undefined,
        friendly_name: undefined,
        order: undefined,
        components: [],
    }) {
        super(data);
        this.id = (0, defaults_1.defaultString)(data.id);
        this.friendly_name = (0, defaults_1.defaultString)(data.friendly_name);
        this.order = (0, defaults_1.defaultNumber)(data.order);
        this.components = data.components.map((cont) => new component_1.default(cont));
    }
    get friendlyName() {
        return this.friendly_name;
    }
    getComponentsCount(predicate) {
        return this.components.reduce((count, component) => (predicate(component) ? count + 1 : count), 0);
    }
    get multilineComponentsCount() {
        return this.getComponentsCount((component) => component.component === component_1.ComponentTypes.MULTILINE);
    }
    get timeComponentsCount() {
        return this.getComponentsCount((component) => component.component === component_1.ComponentTypes.TIME);
    }
    get multipleChoiceComponentsCount() {
        return this.getComponentsCount((component) => component.component === component_1.ComponentTypes.MULTIPLE_CHOICE);
    }
    get checklistComponentsCount() {
        return this.getComponentsCount((component) => component.component === component_1.ComponentTypes.CHECKLIST && !!component.referenceID);
    }
    get checklistInputComponentsCount() {
        return this.getComponentsCount((component) => component.component === component_1.ComponentTypes.CHECKLIST && !component.referenceID);
    }
    get miniActionsOfTheDayCount() {
        return 0; // TODO: WHAT IS THIS
    }
}
exports.default = Page;
